import React, { useMemo } from 'react';
import GridLayout, { Layout, WidthProvider } from 'react-grid-layout';
import { Empty } from 'antd';
import { findNode } from '../../utils/treeUtils';
import ImageWithSpinner from '../content/imagewithspinner';
import { TreeNode } from '../../types/types'; // Use your shared type

interface PageViewProps {
    pageTreeData: TreeNode[];
    selectedKey: string;
}

const ResponsiveGridLayout = WidthProvider(GridLayout);

const PageView: React.FC<PageViewProps> = ({ pageTreeData, selectedKey }) => {
    const selectedPage = useMemo<TreeNode | null>(
        () => findNode(pageTreeData, selectedKey) ?? null,
        [pageTreeData, selectedKey]
    );

    if (!selectedPage || !selectedPage.children || selectedPage.children.length === 0) {
        return <Empty description="No children found for the selected page" />;
    }

    const transformLayout = (children: TreeNode[]): Layout[] => {
        return children.map((child, index) => ({
            i: child.key,
            x: index % 2,
            y: Math.floor(index / 2),
            w: 1,
            h: 1,
        }));
    };

    const layout = transformLayout(selectedPage.children);

    return (
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 10px' }}>
            <ResponsiveGridLayout
                className="layout"
                layout={layout}
                cols={2}
                rowHeight={180}
                margin={[40, 40]}
                containerPadding={[70, 10]}
                isDraggable={false}
                isResizable={false}
            >
                {selectedPage.children.map((child) => (
                    <div key={child.key} style={{ textAlign: 'center' }}>
                        <ImageWithSpinner
                            imageUrl={child?.imageUrl}
                            title={child?.name ?? child.title}
                        />
                    </div>
                ))}
            </ResponsiveGridLayout>
        </div>
    );
};

export default PageView;